import React, { useMemo, Fragment, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Loading from 'components/Loading'
import Divider from '../../../Divider'

import _ from 'lodash'
import localization from './localization'
import NoData from '../../../MyHealthContentArea/NoDataAvailableBar'
import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import { sortImmunizations } from '@web/helpers/sortBy'

import { GridRow, GridColumn, Grid } from 'semantic-ui-react'
import FhirEnhancedTypes from '@web/stores/FhirEnhanced/Actions'
import Button from '@web/components/LoadMoreButton'
import SthWentWrong from 'containers/MyHealth/components/MyHealthContentArea/SthWentWrong'
import withLocalization from '@web/helpers/localizationUtils'
import LearnMoreButton from '@web/components/HealthLibraryLearnMore'
import {
  healthLibrary,
  healthLibraryLoading
} from '@web/stores/FhirEnhanced/Select'
import {
  parseHealthLibrary,
  parseImmunizations
} from '@web/helpers/parseEnhanced'
import { useTranslation } from 'react-i18next'
import { HEALTH_LIBRARY_MAPPING } from '@web/helpers/sources'

const Immunizations = ({ name, loading, data, error, t }) => {
  const { theme } = useTheme()
  const styles = themeStyles(theme)
  const items = useMemo(
    () => parseImmunizations(sortImmunizations(data)),
    [data]
  )
  const dispatch = useDispatch()
  const nextUrl = _.filter(data?.link, item => item.relation === 'next')[0]?.url

  const healthArticles = useSelector(healthLibrary)
  const [healthArticleData, setHealthArticleData] = useState([])
  const [currentArticleCode, setCurrentArticleCode] = useState('')
  const healthArticlesLoading = useSelector(healthLibraryLoading)
  const { i18n } = useTranslation()
  const language = i18n.language === 'es' ? 'es' : 'en'

  useEffect(
    () => {
      if (!healthArticlesLoading?.[currentArticleCode]) {
        const healthArticleData = _.get(
          healthArticles?.[language],
          currentArticleCode,
          []
        )
        const parsedData = parseHealthLibrary(healthArticleData)
        setHealthArticleData(parsedData)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [healthArticlesLoading?.[currentArticleCode]]
  )

  const openLearnMorePopup = ({ terms }) => {
    const key = terms
    const healthArticleData = _.get(healthArticles?.[language], key, [])
    setCurrentArticleCode(key)
    if (!_.isEmpty(healthArticleData)) {
      const parsedData = parseHealthLibrary(healthArticleData)
      setHealthArticleData(parsedData)
    } else if (!healthArticlesLoading?.[key]) {
      dispatch(
        FhirEnhancedTypes.healthLibrarySearch(
          language,
          terms,
          undefined,
          HEALTH_LIBRARY_MAPPING.IMMUNIZATION
        )
      )
    }
  }
  const handleCloseLearnMorePopup = () => {
    setHealthArticleData([])
  }

  const loadMoreOnClick = () => {
    dispatch(FhirEnhancedTypes.immunizationSearchLoadMore(nextUrl))
  }

  return (
    <>
      <div style={styles.container}>
        {loading && _.isEmpty(items) && <Loading />}
        {!_.isEmpty(items) &&
          items.map((item, index) => {
            return (
              <Fragment key={index}>
                <div className='item-container'>
                  <Grid>
                    <GridRow>
                      <GridColumn width={8}>
                        <div style={styles.vaccineItem}>{t('vaccine')}</div>
                      </GridColumn>
                      <GridColumn width={6}>
                        <div style={styles.dateItem}>{t('datesOnFile')}</div>
                      </GridColumn>
                    </GridRow>
                  </Grid>
                  <Grid>
                    <GridRow style={styles.noPaddingTop}>
                      <GridColumn width={8}>
                        <div style={styles.itemName}>
                          {_.get(item, 'title')}
                        </div>
                      </GridColumn>
                      <GridColumn width={6}>
                        <div style={styles.date}>{_.get(item, 'date')}</div>
                      </GridColumn>
                    </GridRow>
                  </Grid>
                  <Grid>
                    <GridRow style={styles.learnMoreContainer}>
                      <GridColumn width={16}>
                        <LearnMoreButton
                          data={healthArticleData}
                          onClick={() =>
                            openLearnMorePopup({ terms: item?.title })
                          }
                          onClose={handleCloseLearnMorePopup}
                          shouldLoading={
                            healthArticlesLoading?.[currentArticleCode]
                          }
                          mapKey={item?.title}
                          buttonStyle={styles.learnMoreButton}
                          language={language}
                        />
                      </GridColumn>
                    </GridRow>
                  </Grid>
                  {index !== items.length - 1 && <Divider />}
                </div>
              </Fragment>
            )
          })}
        {!loading &&
          _.isEmpty(items) &&
          (error ? <SthWentWrong /> : <NoData name={name} />)}
      </div>
      {!_.isEmpty(items) && nextUrl && (
        <Button loading={loading} onClick={loadMoreOnClick} />
      )}
    </>
  )
}

export default withLocalization(Immunizations, localization)
